import React, { Component } from 'react'; 
import LoginNavigationBar from '../../Common/Layouts/NavigationBar/LoginNavigationBar';
// import '../Assets/EnsembleStyles/EnsHome.css';
//import { getUserPreferences } from '../../../../action/cultureAction';


class Forbidden extends Component {
    // componentWillMount() {
    //    this.props.getUserPreferences();
    // }
    render() {
        return (
            <div>
             <LoginNavigationBar />
             <h2>Forbidden</h2>
            </div>
        );
    }
}


// const mapDispatchToProps = dispatch => {
//     return {
//         getUserPreferences: () => dispatch(getUserPreferences()),
//     };
// };

// export default connect(null, mapDispatchToProps)(EnsembleLogin);
export default Forbidden;

